<div class="bg-white">
  <!-- leaderboard ad -->
<div
  class="w-100 justify-content-center align-items-center d-none d-lg-flex py-3"
>
  <div
    class="leaderboard-center skeleton leaderboard-skeleton"
  ></div>
</div>

<main class="container container-fluid min-vh-100 pt-4">
  <div class="row">
    <div class="col-12 col-lg-8 pt-3 border-lg-right mb-10">
      <div class="row">
        <!-- individual list items -->
        <div class="px-4 px-md-0 pb-5">
          <div *ngFor="let item of [0, 1, 2, 3, 4, 5]" class="d-flex flex-row justify-content-between me-3">
            <div
              class="img-fluid rounded mb-3 me-3 skeleton"
              style="height: 132px; width: 100%"
            ></div>
            <p class="p-skeleton"></p>
          </div>
        </div>
      </div>
    </div>
    <div class="d-none d-md-block col-lg-4 pt-3">
      <!-- right rail rectangle ad -->
      <div class="skeleton ad-rectangle-skeleton"></div>
    </div>
  </div>
</main>
</div>
